import { useCallback, useEffect, useMemo } from "react"
import { routes } from "common/navigationRoutes"

const normalizePath = (pathname) => {
  const path = pathname.toLowerCase()
  return path.endsWith("/") ? path.slice(0, -1) : path
}

const useGameNavigation = ({
  location,
  getCategories,
  getGames,
  exercisesContent,
  exerciseContentIndex,
  setCountdownCompleted,
  setActiveContent,
}) => {
  const fetchGameById = useCallback(
    async (gameId) => {
      try {
        const categories = await getCategories()
        for (const category of categories) {
          const gamesList = await getGames({
            categoryId: category.gameCategoryId,
          })
          const found = gamesList.find((g) => g.gameId === gameId)
          if (found) {
            return {
              ...found,
              id: found.gameId,
              title: found.name,
              time: found.durationLabel,
              xp: found.maxPoints,
              color: found.metadata?.colors?.primary,
              colors: [
                found.metadata?.colors?.primary,
                found.metadata?.colors?.secondary,
              ],
              icon: found.iconEmoji,
            }
          }
        }
      } catch (e) {
        console.error("Error fetching game by ID:", e)
      }
      return null
    },
    [getCategories, getGames]
  )

  // Reset countdown when returning to games list
  useEffect(() => {
    const normalizedPath = normalizePath(location.pathname)
    const isGamesList = normalizedPath.endsWith(routes.NEW_GAMES)
    if (isGamesList) {
      setCountdownCompleted(false)
    }
  }, [location.pathname])

  // Track active content for exercises
  useEffect(() => {
    const currentExercise = exercisesContent[exerciseContentIndex]
    if (
      currentExercise?.exerciseId > 0 &&
      currentExercise?.moduleActivityId > 0
    ) {
      setActiveContent({
        relatedId: currentExercise?.moduleActivityId,
        subRelatedId: currentExercise?.exerciseId,
        screen: "games",
      })
    }
  }, [exercisesContent, exerciseContentIndex])

  const isPlayingGame = useMemo(() => {
    const normalizedPath = normalizePath(location.pathname)
    const isGamesList = normalizedPath.endsWith(routes.NEW_GAMES)
    return normalizedPath.includes(routes.NEW_GAMES) && !isGamesList
  }, [location.pathname])

  return {
    fetchGameById,
    isPlayingGame,
  }
}

export default useGameNavigation
